<div class="year-wrapper">
  <app-menu-year [months]="months" [current]="currentMonth.index" (change)="navigateMonth($event)"></app-menu-year>
</div>

<div class="center-wrapper">
  <div class="header">
    <div class="header-date-picker">
      <a class="date--prev" *ngIf="prevWeek" [routerLink]="['/menu/week', prevWeek]"></a>
      <app-title icon="menu_over">
        Jedilniki: {{ dateJs.week() }}. teden
      </app-title>
      <a class="date--next" *ngIf="nextWeek" [routerLink]="['/menu/week', nextWeek]"></a>
    </div>
<!--    <div class="month-summary">-->
<!--      <span>Povprečna cena na dan:</span>-->
<!--      <span>-->
<!--        <ng-container *ngIf="avgCost">-->
<!--          {{ avgCost | number:'1.0-2' }} €-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!avgCost">-</ng-container>-->
<!--      </span>-->
<!--      <span>Delež ekoloških izdelkov:</span>-->
<!--      <span>-->
<!--        <ng-container *ngIf="ecoRatio">-->
<!--          {{ ecoRatio | percent }}-->
<!--        </ng-container>-->
<!--        <ng-container *ngIf="!ecoRatio">-</ng-container>-->
<!--      </span>-->
<!--    </div>-->
    <app-toggle-help>Jedilniki so urejeni po mesecih, vnašate jih lahko po dnevih in skupinah uporabnikov. Potrjeni dnevi so obarvani zeleno. V dnevnem pogledu lahko v stolpcih »Tedenska pogostnost« in »Dnevno povprečje« spremljate skladnost jedilnika s prehranskimi smernicami. Siva barva označuje skupine živil, ki jih še niste vključili. Potrjevanje jedilnika za posamezno skupino naročnikov poteka v dnevnem pogledu jedilnika.</app-toggle-help>
  </div>

  <div class="white-container">
    <app-meal-size-picker [sizes]="availableSizes" [selectedSize]="selectedSize"
                          [sizeStatuses]="sizeStatuses" (selected)="sizeSelected($event)"></app-meal-size-picker>
    <div class="container">
      <div class="weekly-part">
        <div class="weekdays">
          <div *ngFor="let day of days">{{ day.date.format('dddd') }}</div>
        </div>
        <div class="week-around week-around--before">
          <div *ngFor="let day of daysBefore; let index = index" class="{{day.statusClass}}">
            <span class="week-around---week" *ngIf="index % 7 == 0" (click)="navigateWeek(day.week)">{{ day.week }}</span>
            <span class="week-around---day" (click)="navigateDay(day.date)">{{ day.index }}</span>
          </div>
        </div>
        <div class="week">
          <ng-container *ngFor="let day of days; let index = index">
            <div class="week--monthday {{ day.statusClass }}">
              <span class="week--monthday--week" *ngIf="index === 0" (click)="navigateCurrentMonth()">{{ day.week }}</span>
              <span class="week--monthday--day" (click)="navigateDay(day.date)">{{ day.date.format('D.') }}</span>
            </div>
          </ng-container>
          <ng-container *ngFor="let mealCode of availableMeals">
            <div class="week--meal" (click)="navigateDay(day.date)" *ngFor="let day of days"><ng-container *ngIf="day.statusClass">
              <div class="week--mealname">{{ mealCode | mealName }}</div>
              <app-value-bar class="week--mealenergy" [value]="day.mealEnergy.get(mealCode)" color="energy"></app-value-bar>
              <div class="week--mealfoods">{{ day.mealFoods.get(mealCode) }}</div>
            </ng-container></div>
          </ng-container>
          <div class="week--nutrients" (click)="navigateDay(day.date)" *ngFor="let day of days">
            <ng-container *ngIf="day.statusClass && day.nutrients">
              <app-component-pie [values]="day.nutrients.values"></app-component-pie>
              <app-value-bar [value]="day.energy" [min]="guidelines.minDayEnergy" [max]="guidelines.maxDayEnergy" color="energy" [showGuide]="true"></app-value-bar>
              <div class="component-mark" [class.valid]="day.allComponentValid"></div>
              <div class="component-bar sugar" [class.valid]="day.componentValid[0]"><span [style.width]="day.componentWidths[0]"></span></div>
              <div class="component-bar sodium" [class.valid]="day.componentValid[1]"><span [style.width]="day.componentWidths[1]"></span></div>
              <div class="component-bar fasat" [class.valid]="day.componentValid[2]"><span [style.width]="day.componentWidths[2]"></span></div>
            </ng-container>
            <span *ngIf="day.statusClass && !day.nutrients"></span>
          </div>
        </div>
        <div class="week-around week-around--after">
          <div *ngFor="let day of daysAfter; let index = index" class="{{day.statusClass}}">
            <span class="week-around---week" *ngIf="index % 7 == 0" (click)="navigateWeek(day.week)">{{ day.week }}</span>
            <span class="week-around---day" (click)="navigateDay(day.date)">{{ day.index }}</span>
          </div>
        </div>
      </div>
      <div class="container-aside">
        <div class="sidebar-title">
          Sestava obrokov
        </div>
        <app-menu-sidebar [values]="weekValues" [units]="weekUnits" [guidelines]="guidelines"> </app-menu-sidebar>
      </div>
    </div>
  </div>
</div>
